import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.css']
})

export class ReservationsComponent implements OnInit {
  ngOnInit(){
    }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/pages/reservations/reservations.component.ts